import { render, staticRenderFns } from "./price-total.vue?vue&type=template&id=6c119149&scoped=true&"
import script from "./price-total.vue?vue&type=script&lang=js&"
export * from "./price-total.vue?vue&type=script&lang=js&"
import style0 from "./price-total.vue?vue&type=style&index=0&id=6c119149&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c119149",
  null
  
)

export default component.exports